import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SalesOrderPrintInvoice = lazy(() => import('./pages/print/SalesOrderPrintInvoice'));
const SalesOrderPrintPicker = lazy(() => import('./pages/print/SalesOrderPrintPicker'));
const SalesOrderPrintDeliveryLabel = lazy(() => import('./pages/print/SalesOrderPrintDeliveryLabel'));

/**
 * Standalone print routes — authenticated but rendered outside MainLayout
 * (no Sidebar/Header), each fetching its own data so the URL is directly
 * linkable and refreshable. Registered separately from routes.tsx because
 * these must NOT be nested under the `sales` MainLayout route.
 */
const salesPrintRoutes: RouteObject[] = [
  { path: '/sales/orders/:id/print/invoice', element: <SalesOrderPrintInvoice /> },
  { path: '/sales/orders/:id/print/picker', element: <SalesOrderPrintPicker /> },
  { path: '/sales/orders/:id/print/delivery-label', element: <SalesOrderPrintDeliveryLabel /> },
];

export default salesPrintRoutes;
